// Keeps Japanese phrases intact when headings wrap (breaks only after 、 or 。).
export const Phrases = ({ text }) =>
  text.split(/(?<=[、。])/).map((p, i) => (
    <span key={i} className="inline-block">
      {p}
    </span>
  ));
